




























import './AuthenticatorForm.scss'
import { defineComponent } from '@vue/composition-api'
import { KisweButton, KisweForm, KisweSpinner } from '@/modules/kisweui/components'
import { TranslateResult } from 'vue-i18n'

export default defineComponent({
  name: 'AuthenticatorForm',
  components: {
    KisweButton,
    KisweForm,
    KisweSpinner
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isRequesting: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonLabel: {
      type: String as () => string|TranslateResult,
      required: false,
      default: 'Log in'
    }
  },
  emits: {
    submit () { return true }
  }
})
